const MS_PER_DAY = 24 * 60 * 60 * 1000;

export function parseISODate(value) {
  if (value instanceof Date) {
    const parsed = new Date(value.getTime());
    parsed.setUTCHours(12, 0, 0, 0);
    return parsed;
  }

  if (typeof value !== "string" || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
    return new Date(NaN);
  }
  const parsed = new Date(`${value}T12:00:00Z`);
  // Date normalizes impossible dates (for example February 30); reject them.
  return Number.isFinite(parsed.getTime()) && parsed.toISOString().slice(0, 10) === value
    ? parsed
    : new Date(NaN);
}

export function toISODateString(value) {
  return parseISODate(value).toISOString().slice(0, 10);
}

function getDaysInMonth(year, monthIndex) {
  return new Date(Date.UTC(year, monthIndex + 1, 0)).getUTCDate();
}

export function getDefaultFilmingOffsetMonths(season) {
  if (season <= 2) {
    return 3;
  }

  if (season <= 5) {
    return 4;
  }

  return 5;
}

export function getEstimatedFilmingDate(airDate, offsetMonths = 3) {
  const parsed = parseISODate(airDate);
  const year = parsed.getUTCFullYear();
  const monthIndex = parsed.getUTCMonth();
  const day = parsed.getUTCDate();
  const absoluteMonths = year * 12 + monthIndex - offsetMonths;
  const targetYear = Math.floor(absoluteMonths / 12);
  const targetMonthIndex = ((absoluteMonths % 12) + 12) % 12;
  const targetDay = Math.min(day, getDaysInMonth(targetYear, targetMonthIndex));

  return toISODateString(new Date(Date.UTC(targetYear, targetMonthIndex, targetDay)));
}

export function getAgeAtDate(dob, targetDate) {
  const birthDate = parseISODate(dob);
  const target = parseISODate(targetDate);

  if (!Number.isFinite(birthDate.getTime()) || !Number.isFinite(target.getTime()) || target < birthDate) {
    return null;
  }

  const birthMonth = birthDate.getUTCMonth();
  const birthDay = birthDate.getUTCDate();
  const targetYear = target.getUTCFullYear();

  let lastBirthday = new Date(Date.UTC(targetYear, birthMonth, birthDay, 12));
  if (target < lastBirthday) {
    lastBirthday = new Date(Date.UTC(targetYear - 1, birthMonth, birthDay, 12));
  }

  const nextBirthday = new Date(
    Date.UTC(lastBirthday.getUTCFullYear() + 1, birthMonth, birthDay, 12),
  );
  const wholeYears = lastBirthday.getUTCFullYear() - birthDate.getUTCFullYear();
  const fraction = (target - lastBirthday) / (nextBirthday - lastBirthday);
  const exact = wholeYears + fraction;

  return Number.isFinite(exact) ? exact : wholeYears;
}

export function getWholeAgeAtDate(dob, targetDate) {
  const age = getAgeAtDate(dob, targetDate);
  return age === null ? null : Math.floor(age);
}

export function getDateDeltaDays(startDate, endDate) {
  return Math.round((parseISODate(endDate) - parseISODate(startDate)) / MS_PER_DAY);
}
